import React from 'react';
import { Button, Flex } from '@chakra-ui/react';
import { KModal } from '@/ui-library/components/molecules/KModal';
import { KText } from '@/ui-library/components/text';
import { useKFlags } from '@/hooks/use-k-flags';

interface AiScoringRerunModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSaveWithoutRetrigger: () => void;
  onSaveAndRetrigger: () => void;
  isLoading?: boolean;
  loadingAction?: 'saveWithoutRetrigger' | 'saveAndRetrigger' | null;
}

export const AiScoringRerunModal: React.FC<AiScoringRerunModalProps> = ({
  isOpen,
  onClose,
  onSaveWithoutRetrigger: _onSaveWithoutRetrigger,
  onSaveAndRetrigger,
  isLoading = false,
  loadingAction = null,
}) => {
  const { feJobTeammates } = useKFlags();
  return (
    <KModal
      isOpen={isOpen}
      onClose={onClose}
      title={feJobTeammates ? 'Update the scoring agent?' : 'Update AI scoring'}
      size="md"
      footer={false}
    >
      <Flex flexDir="column" gap="16px">
        <KText>
          {feJobTeammates
            ? 'Scoring agent scores will be recalculated for the candidates in this job'
            : 'AI scores will be recalculated for the candidates in this job'}
        </KText>

        <Flex gap="12px" justifyContent="flex-end" pb="6px">
          <Button
            variant="secondary"
            // onClick={onSaveWithoutRetrigger}
            onClick={onClose}
            disabled={isLoading}
            isLoading={isLoading && loadingAction === 'saveWithoutRetrigger'}
            loadingText="Saving..."
          >
            Cancel
            {/* Save without re-running */}
          </Button>
          <Button
            variant="primary"
            onClick={onSaveAndRetrigger}
            disabled={isLoading}
            isLoading={isLoading && loadingAction === 'saveAndRetrigger'}
            loadingText="Saving and re-running..."
          >
            Confirm
            {/* Save and re-run scoring */}
          </Button>
        </Flex>
      </Flex>
    </KModal>
  );
};
